import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 50%;
  height: 100%;
  margin-top: 50px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  margin-bottom: 50px;
  width: 100%;
`;

export const Data = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.85);
`;

export const Value = styled.div`
  display: flex;
  align-items: center;
  margin-top: 3px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.5);
`;

const ValueWrapper = styled.span`
  height: 22px;
  display: flex;
  align-items: center;
`;

export const ValueNumberWrapper = styled(ValueWrapper)``;

export const ValueIconWrapper = styled(ValueWrapper)`
  margin-left: 4px;
`;
